import { Phone, MapPin, Mail, ShieldCheck } from "lucide-react";
import { BRAND, telHref, LOGO_URL } from "@/lib/brand";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#0a0a0a] text-white py-14"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
                    <div className="md:col-span-2">
                        <div className="flex items-center gap-3 mb-4">
                            <img
                                src={LOGO_URL}
                                alt="Stronger Solutions"
                                className="h-12 w-12 object-contain"
                            />
                            <div className="font-display font-bold text-lg">
                                {BRAND.name}
                            </div>
                        </div>
                        <p className="text-sm text-gray-400 max-w-md leading-relaxed">
                            Professional pressure washing, window cleaning, and
                            commercial services across Georgia. Owned and
                            operated by Jefferson.
                        </p>
                        <div className="mt-6 flex items-center gap-2 text-xs text-gray-400">
                            <ShieldCheck className="w-4 h-4 text-[#1E88E5]" />
                            Safe Hands · Peace of Mind You Can Count On
                        </div>
                    </div>

                    <div>
                        <div className="text-xs uppercase tracking-widest text-[#1E88E5] font-bold mb-4">
                            Services
                        </div>
                        <ul className="space-y-2 text-sm text-gray-300">
                            <li>Pressure Washing</li>
                            <li>Window Cleaning</li>
                            <li>House Washing</li>
                            <li>Deck & Patio</li>
                            <li>Commercial</li>
                        </ul>
                    </div>

                    <div>
                        <div className="text-xs uppercase tracking-widest text-[#1E88E5] font-bold mb-4">
                            Contact
                        </div>
                        <ul className="space-y-3 text-sm">
                            <li>
                                <a
                                    href={telHref}
                                    data-testid="footer-phone"
                                    className="flex items-center gap-2 text-gray-300 hover:text-white"
                                >
                                    <Phone className="w-4 h-4 text-[#1E88E5]" />
                                    {BRAND.phoneDisplay}
                                </a>
                            </li>
                            <li className="flex items-center gap-2 text-gray-300">
                                <MapPin className="w-4 h-4 text-[#1E88E5]" />
                                {BRAND.location}
                            </li>
                            <li className="flex items-center gap-2 text-gray-300">
                                <Mail className="w-4 h-4 text-[#1E88E5]" />
                                Jefferson · Owner
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-gray-500">
                    <div>
                        © {new Date().getFullYear()} Stronger Solutions. All
                        rights reserved.
                    </div>
                    <div className="font-display italic text-[#1E88E5]">
                        {BRAND.taglineScript}
                    </div>
                </div>
            </div>
        </footer>
    );
}
